<template>
    <div @scroll="handleScroll">
        <InnerLoader v-if="isLoading" color="var(--text-color)" />
        <Draggable
            v-bind="dragOptions"
            @start="drag = true"
            @end="drag = false"
            :list="sourceReports"
            class="list-group"
            group="reports"
        >
            <div v-for="element in sourceReports" :key="element._id.$oid" class="list-group-item">
                <div class="flex justify-between items-center">
                    <div class="flex flex-col title-column">
                        <div class="text-sm font-bold mb-1">
                            <div class="truncate">
                                {{ element.name || `[${$t('report_live_play')}]` }}
                            </div>
                            <div class="truncate font-size-12 font-normal">
                                {{ element.quiz.title }}
                            </div>
                        </div>
                        <div class="text-xs">{{ element.created_at_readable }}</div>
                    </div>
                    <div class="text-sm flex items-center ml-2" style="width: 48px">
                        <i class="far fa-user mr-1"></i>
                        <span>{{ element.player_number || 'N/A' }}</span>
                    </div>
                    <div class="mx-2">
                        <i @click.prevent="moveToTarget(element)" class="fas fa-plus cursor-pointer"></i>
                    </div>
                </div>
            </div>
        </Draggable>
        <div
            v-if="sourceReports.length === 0"
            v-html="$t('merge_report_no_source_report')"
            class="no-source-report text-center font-bold flex justify-center items-center h-full py-2"
        ></div>
    </div>
</template>

<script>
import appConfig from '@/app.config'
import Request from '@/lib/request'
import UserService from '@/lib/user'
import Draggable from 'vuedraggable'
import InnerLoader from '@/components/InnerLoader'

export default {
    components: {
        Draggable,
        InnerLoader
    },

    props: {
        selectedQuiz: {
            type: Object,
            default: null
        },

        targetReports: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        dragOptions() {
            return {
                animation: 200,
                ghostClass: 'ghost'
            }
        }
    },

    data() {
        return {
            sourceReports: [],
            cacheSourceReports: [],
            drag: false,
            isLoading: false,
            currentPage: 1,
            pageCount: 0
        }
    },

    methods: {
        createRequest() {
            const userService = new UserService()
            const token = userService.getToken()

            return new Request({
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
        },

        getReportByQuiz() {
            this.isLoading = true
            const quizId = this.selectedQuiz.id
            const request = this.createRequest()
            const url = appConfig.api.getReportAllByUser

            request
                .get(url, { params: { page: this.currentPage, id: quizId, filter_type: 'mine' } })
                .then(res => {
                    const ids = this.sourceReports.map(item => item._id.$oid)
                    const source = res.data.data.data.filter(item => !ids.includes(item._id.$oid))

                    this.cacheSourceReports = this.cacheSourceReports.concat(res.data.data.data)
                    this.$store.commit('setOriginalUserReports', JSON.parse(JSON.stringify(this.cacheSourceReports)))

                    this.sourceReports = this.sourceReports.concat(source)
                    this.pageCount = parseInt(res.data.data.page_count)
                    this.currentPage = parseInt(res.data.data.current_page)
                    this.totalItems = parseInt(res.data.data.total)

                    this.sourceReports = this.sourceReports.map(item => {
                        item.is_my_report = true
                        item.quiz = {
                            _id: {
                                $oid: item.quiz_id ? item.quiz_id.$oid : item.quiz_id
                            },
                            title: Array.isArray(item.quiz) ? item.quiz[0].title : item.quiz.title
                        }

                        return item
                    })

                    //Filter out reports from sourceReports that are already present in targetReports.
                    this.sourceReports = this.sourceReports.filter(item => {
                        return !this.targetReports.find(target => target._id.$oid === item._id.$oid)
                    })

                    this.$emit('data', this.sourceReports)
                    this.isLoading = false
                })
                .catch(() => {
                    this.clearList()
                    this.isLoading = false
                })
        },

        handleScroll(event) {
            const scrollableElement = event.target
            const scrollHeight = scrollableElement.scrollHeight
            const scrollTop = scrollableElement.scrollTop
            const clientHeight = scrollableElement.clientHeight

            // Check if the user has scrolled to the bottom
            const bottom = scrollHeight <= scrollTop + clientHeight + 1

            if (bottom && !this.isLoading && this.currentPage < this.pageCount) {
                if (this.selectedQuiz) {
                    this.currentPage++
                    this.getReportByQuiz()
                }
            }
        },

        moveToTarget(element) {
            this.$emit('move-to-target', element)
        },

        clearList() {
            this.sourceReports = []
            this.cacheSourceReports = []
            this.currentPage = 1
            this.$emit('data', this.sourceReports)
        }
    }
}
</script>
